import { useDispatch, useSelector } from "react-redux";
import { setSendData } from "../../../Store/Slice/scheduleSlice";
import { useEffect } from "react";

const useSetPrimaryContact = () => {
  const accountIndex = useSelector(
    (state) => state.rootReducer.techsbookSlice.userData
  );
  const dispatch = useDispatch();
  const { primary_contact } = useSelector(
    (state) => state.rootReducer.scheduleSlice.sendData
  );

  const set = (value) => {
    dispatch(
      setSendData({ primary_contact: { ...primary_contact, ...value } })
    );
  };

  useEffect(() => {
    dispatch(
      setSendData({
        primary_contact: {
          ...primary_contact,
          lastname: accountIndex?.lastname,
          email: accountIndex?.email,
          firstname: accountIndex?.firstname,
        },
      })
    );
  }, [accountIndex]);

  return {
    set,
  };
};

export default useSetPrimaryContact;
